<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <head-navition> </head-navition>
    <router-view />
    <footer-bottom></footer-bottom>
  </div>
</template>
<script>
import headNavition from '../src/components/headNavition.vue'
import footerBottom from '../src/components/footer.vue'
import { setToken } from './until/token'
import { token } from './api/http'
export default {
  components: {
    headNavition,
    footerBottom
  },
  mounted() {
    this.getToken()
  },
  methods: {
    getToken() {
      let data = {
        username: "admin",
        password: "admin123"
      };
      token(data).then(res => {
        console.log('获取token', res);
        if (res.code == 200) {
          setToken(res.token)
        }

      })
    }
  }
}
</script>
<style>
#navbar .routerActive {
  color: #cb9334;
  border-bottom: 5px solid #cb9334;
}
body,
div,
p,
ul,
li {
  margin: 0;
  padding: 0;
}
.flex {
  display: flex;
}
.flex_left {
  justify-content: start;
}
.flex_warp {
  flex-wrap: wrap;
}
.flex_right {
  justify-content: end;
}
.flex_center {
  justify-content: center;
}
.flex_b_t_w {
  justify-content: space-between;
}
.alian_center {
  align-items: center;
}
.text_center {
  text-align: center;
}
ul {
  padding-left: 0;
  margin-bottom: 0;
}
li {
  list-style-type: none;
}
a {
  text-decoration: none;
  color: #333;
}
input {
  border: none;
  outline: none;
}
button {
  border: none;
}
.web_maxWitch {
  max-width: 1920px;
}
.web_minWitch {
  min-width: 1296px;
}
/* img {
  vertical-align: middle;
} */
</style>
